export default __webpack_public_path__ + "static/media/Verizon_Media-Logo.wine.6770cece.svg";